import { CellIcon } from './CellIcon';

class StaticCellIcon extends CellIcon {

}

export {
  StaticCellIcon,
};
